import type { Tile } from '../../hex/types';
import { extractRegionResources } from '../factory/regionResourcesFactory';
import type { Settlement } from '../types';

export function recalculateRegionResources(settlement: Settlement, tiles: Tile[]): void {
    settlement.regionResources = extractRegionResources(tiles);
}
